export default __webpack_public_path__ + "static/media/1970.df447426.png";